import React, { useState, useEffect } from 'react';
import '../styles/GeneralStyles.css';
import iconRadio1 from '../assets/ring-vector-1.svg'
import iconArrowLeft from '../assets/arrow-left.svg'
import iconArrowRight from '../assets/arrow-right.svg'
import imgSl1 from '../assets/montadura-imgs/tressormontadurasl15.webp'
import imgSl2 from '../assets/montadura-imgs/tressormontadurasl2.webp'
import imgSl3 from '../assets/montadura-imgs/tressormontadurasl3.webp'
import imgSl5 from '../assets/montadura-imgs/tressormontadurasl5.webp'
import imgSl8 from '../assets/montadura-imgs/tressormontadurasl8.webp'
import imgSl10 from '../assets/montadura-imgs/tressormontadurasl10.webp'
import imgSl12 from '../assets/montadura-imgs/tressormontadurasl12.webp'
import imgSl15 from '../assets/montadura-imgs/tressormontadurasl1.webp'
import portadaMontura from '../assets/portadas/Portada-06-Montura.webp'

const Step5 = ({ nextStep, prevStep, handleInputChange, formData, isSubmitting }) => {
  const [selectedOption, setSelectedOption] = useState(formData?.montura || null);

  useEffect(() => {
    if (formData?.montura) {
      setSelectedOption(formData.montura);
    }
  }, [formData]);

  const options = [
    {
      id: 1,
      icon: iconRadio1,
      text: "Tressor SL-1",
      value: 0,
      title: "SL-1",
      description: "Media caña tradicional a 4 uñas con brazos en “v”",
      image: imgSl1,
    },
    {
      id: 2,
      icon: iconRadio1,
      text: "Tressor SL-2",
      value: 0,
      title: "SL-2",
      description: "Media caña tradicional a 4 uñas, con brazo adelgazado",
      image: imgSl2
    },
    {
      id: 3,
      icon: iconRadio1,
      text: "Tressor SL-3",
      value: 0,
      title: "SL-3",
      description: "Media caña tradicional a 4 uñas, brazo continuo",
      image: imgSl3
    },
    {
      id: 4,
      icon: iconRadio1,
      text: "Tressor SL-5",
      value: 0,
      title: "SL-5",
      description: "Media caña tradicional a 4 uñas torcidas",
      image: imgSl5
    },
    {
      id: 5,
      icon: iconRadio1,
      text: "Tressor SL-8",
      value: 0,
      title: "SL-8",
      description: "Montura a 4 uñas con brazo entrelazado",
      image: imgSl8
    },
    {
      id: 6,
      icon: iconRadio1,
      text: "Tressor SL-10",
      value: 0,
      title: "SL-10",
      description: "Montura a 6 uñas",
      image: imgSl10
    },
    {
      id: 7,
      icon: iconRadio1,
      text: "Tressor SL-12",
      value: 0,
      title: "SL-12",
      description: "Modelo tradicional a 6 uñas y diamantes laterales",
      image: imgSl12
    },
    {
      id: 8,
      icon: iconRadio1,
      text: "Tressor SL-15",
      value: 0,
      title: "SL-15",
      description: "Modelo 4 uñas en “U”",
      image: imgSl15
    }
  
  ];

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    handleInputChange('montura', option);
  };

  return (
    <div className='container-large'>
      <div className='wrapp-principal-2-columns'>
        <div className="options-column">
          <div className='text-n-options'>
            <h2 className='heading-style-h3 text-align-center'>Elige la Montura Perfecta</h2>
            <p className='text-size-medium text-color-grey'>Selecciona el modelo que más te guste</p>
            <div className='container-radio-options'>
            <div className='wrapp-radio-options'>
            <div className="radio-options">
              {options.map((option) => (
                <label key={option.id} className="radio-label">
                  <input
                    type="radio"
                    name="setting"
                    checked={selectedOption?.id === option.id}
                    onChange={() => handleOptionSelect(option)}
                  />
                  <img src={option.icon} className="radio-icon" alt="ring icon" />
                  <span className="radio-text">{option.text}</span>
                </label>
              ))}
            </div>
            </div>
            </div>
          </div>
          
        
          <div className="wrapp-btns">
            <button className="button-prev" onClick={prevStep}>
              <img src={iconArrowLeft} alt="arrow left" />
              Volver
            </button>
            <button 
              className="button" 
              onClick={nextStep}
              disabled={!selectedOption}
            >
              Siguiente
              <img src={iconArrowRight} alt="arrow right" />
            </button>
          </div>

        </div>
        
        <div className="preview-column">
          {selectedOption ? (
            <>
              <div className='imgOptionSelected'>
                <img 
                  src={selectedOption.image} 
                  alt={selectedOption.text}
                  className="ring-preview-image"
                />
              </div>
              <div className='textOptionSelected'>
                <h3 className="text-align-left">{selectedOption.title}</h3>
                <p className="text-style-medium text-align-left">
                  {selectedOption.description}
                </p>
              </div>
            </>
          ) : (
            <div className="no-selection-message">
              <img src={portadaMontura} className='imgPreviewNoText' alt="Preview anillo" />
              <div className='wrappNoSelectText'>
                <p className='heading-style-h4 text-weight-bold text-color-white'>Montura</p>
                <p className='text-size-large text-color-white text-align-left'>Por favor selecciona el tipo de montura</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Step5;
